module.exports = __webpack_public_path__ + "img/VNTT.420b828d.png";